// extracted by mini-css-extract-plugin
export default {"editor":"styles_editor__ue4xa","menu_bar":"styles_menu_bar__T5p2h","editable_tiptap":"styles_editable_tiptap__x4UTD","bubble_menu":"styles_bubble_menu__aQ+3r"};